import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Text } from 'rebass'

export default ({ id, values, ...props }) => (
  <Text {...props}>
    <FormattedMessage id={id} values={values} />
  </Text>
)
